import React, { FC, useState } from "react";
import classnames from "classnames";

import { RowProps } from "./types";
import { getKey } from "../../utils";
import Icon from "../../../Icon";
import { IconName } from "../../../Icon/types";

export const Row: FC<RowProps> = ({
  data: rowData,
  columns,
  renderExpandedRow,
  onDoubleClick,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const iconName: IconName = "right";

  const toggleExpanded = () => {
    setIsExpanded((prevIsExpanded) => {
      return !prevIsExpanded;
    });
  };

  const handleDoubleClick = () => {
    onDoubleClick && onDoubleClick(rowData);
  };

  return (
    <>
      <tr
        className={classnames("ams-table__row", className, {
          "ams-table__row--expanded": isExpanded,
        })}
        onDoubleClick={handleDoubleClick}
      >
        {renderExpandedRow ? (
          <td
            className="ams-table__cell ams-table__expand"
            onClick={toggleExpanded}
          >
            <Icon className={classnames({ "ams-icon__active": isExpanded })}>
              {iconName}
            </Icon>
          </td>
        ) : null}
        {columns.map((column, colIndex) => {
          if (!column.cellRenderer) {
            return null;
          }

          const value = column.cellRenderer({ rowData, column });

          return (
            <td
              className={classnames("ams-table__cell", column.cellClass)}
              key={getKey("td", column.field)}
            >
              {value}
            </td>
          );
        })}
      </tr>
      {renderExpandedRow && isExpanded ? (
        <tr>
          <td className="ams-table__expanded_row" colSpan={columns.length + 1}>
            {renderExpandedRow(rowData)}
          </td>
        </tr>
      ) : null}
    </>
  );
};
